var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiAssistantmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.87 2c.2 0 .39.13.45.33l.53 1.56 1.56.53a.48.48 0 0 1 0 .9l-1.56.53-.53 1.56a.48.48 0 0 1-.9 0l-.53-1.56-1.56-.53a.48.48 0 0 1 0-.9l1.56-.53.53-1.56c.06-.2.24-.33.45-.33ZM13.5 17a.5.5 0 0 1-.5-.5v-7c0-.28.22-.5.5-.5h.44c.28 0 .5.22.5.5v7a.5.5 0 0 1-.5.5h-.44ZM5.5 2.7c.26-.93 1.61-.93 1.88 0l3.94 13.66a.5.5 0 0 1-.48.64h-.44a.5.5 0 0 1-.5-.39l-.77-3.3a.2.2 0 0 0-.2-.16H3.78a.2.2 0 0 0-.2.15l-.97 3.34a.5.5 0 0 1-.48.36h-.47a.5.5 0 0 1-.47-.65L5.5 2.7Zm-1.42 8.84a.2.2 0 0 0 .2.26h4.18a.2.2 0 0 0 .2-.26l-2.04-6.9a.2.2 0 0 0-.38-.01l-2.16 6.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantmedium);
export default __webpack_public_path__ + "static/media/aiAssistant.medium.d71f73964515e14cf248c229f1a06293.svg";
export { ForwardRef as ReactComponent };